import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import { useCallback } from "react";
import { useLocation } from "react-router";
import { AssetAttrsBase, DocumentAttrs } from "../../interfaces/api";
import PageHeader from "./PageHeader";
import PageHeaderToolbar from "./PageHeaderToolbar";

// TODO processing.workspace id in OrionManagerGroups
function PageToolbar({
  asset,
  selectedTab,
  setSelectedTab,
}: {
  asset: AssetAttrsBase | undefined;
  selectedTab: number;
  setSelectedTab: Function;
}) {
  return (
    <PageHeaderToolbar>
      {asset && (
        <ButtonGroup>
          <Button
            key="Détails"
            className="mr-2"
            onClick={() => setSelectedTab(0)}
            variant={selectedTab === 0 ? "contained" : "outlined"}
          >
            Détails
          </Button>
          <Button
            key="Chatbot"
            className="mr-2"
            onClick={() => setSelectedTab(1)}
            variant={selectedTab === 1 ? "contained" : "outlined"}
          >
            Chatbot
          </Button>
        </ButtonGroup>
      )}
    </PageHeaderToolbar>
  );
}

function ProcessingPageHeader({
  selectedTab,
  setSelectedTab,
  asset,
  document,
  chatPdf,
}: {
  selectedTab: number;
  setSelectedTab: Function;
  asset: AssetAttrsBase | undefined;
  document: DocumentAttrs | undefined;
  chatPdf: boolean;
}) {
  const location = useLocation();
  const PageToolbarComponent = useCallback(
    () =>
      chatPdf ? (
        <PageToolbar
          asset={asset}
          selectedTab={selectedTab}
          setSelectedTab={setSelectedTab}
        />
      ) : null,
    [chatPdf, asset, selectedTab, setSelectedTab]
  );

  return (
    <PageHeader
      breadcrumbs={
        asset
          ? [
              { title: "Dossiers", path: "/orion/assets" },
              {
                title: asset?.name,
                path: `/orion/asset/${asset?._id}`,
              },
              {
                title: document?.name || "",
                path: location.pathname,
              },
            ]
          : []
      }
      title={document?.name || ""}
      slots={{ toolbar: PageToolbarComponent }}
    />
  );
}

export default ProcessingPageHeader;
